import { render, staticRenderFns } from "./MultipleFlightFields.vue?vue&type=template&id=2b183854&"
import script from "./MultipleFlightFields.vue?vue&type=script&lang=js&"
export * from "./MultipleFlightFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports